// removed by extract-text-webpack-plugin
module.exports = {"accordion":"accordion","accordion__header":"accordion__header","arrow":"arrow","faqs":"faqs","accordion__panel":"accordion__panel"};


//////////////////
// WEBPACK FOOTER
// ./resources/views/library/components/accordion/accordion.scss
// module id = 34
// module chunks = 1